// StoreContext.tsx
import { createContext, ReactNode, useContext } from 'react';

import CompanyRepository from './CompanyRepository/CompanyRepository';
import PackageItemRepository from './PackageItemRepository/PackageItemRepository';
import ReceptionRepository from './ReceptionRepository/ReceptionRepository';
import { ServiceOrderRepository } from './ServiceOrderRepository/ServiceOrderRepository';
import ShipmentRepository from './ShipmentRepository/ShipmentRepository';
import TicketRepository from './TicketRepository/TicketRepository';
import UserRepository from './UserRepository/UserRepository';

interface repositoriesContextType {
  ticketRepository: TicketRepository;
  shipmentRepository: ShipmentRepository;
  receptionRepository: ReceptionRepository;
  packageItemRepository: PackageItemRepository;
  userRepository: UserRepository;
  companyRepository: CompanyRepository;
  serviceOrderRepository: ServiceOrderRepository;
}

const RepositoriesContext = createContext<repositoriesContextType>({} as repositoriesContextType);

export const RepositoriesProvider = ({
  children,
  axiosInstance,
}: {
  children: ReactNode;
  axiosInstance: any;
}) => (
  <RepositoriesContext.Provider
    value={{
      ticketRepository: new TicketRepository(axiosInstance),
      shipmentRepository: new ShipmentRepository(axiosInstance),
      receptionRepository: new ReceptionRepository(axiosInstance),
      packageItemRepository: new PackageItemRepository(axiosInstance),
      userRepository: new UserRepository(axiosInstance),
      companyRepository: new CompanyRepository(axiosInstance),
      serviceOrderRepository: new ServiceOrderRepository(axiosInstance),
    }}>
    {children}
  </RepositoriesContext.Provider>
);

export const useRepositoriesContext = () => useContext(RepositoriesContext);
